import React from 'react';
import typingBalls from '../../../../../assets/typing-balls-light.svg';

export const TypingIndicator: React.FC = () => {
    return (
        <div className="h-[28px] w-[28px] overflow-y-hidden ml-1">
            <img
                role="presentation"
                className="duration-230 animate-[2.3s_infinite_steps(68)_custom-animation]"
                src={typingBalls}
            />
        </div>
    );
};
